export const TR_AR = {
  // SEO overhaul: directory, pagination, profile facts
  lawyers_level_label: "درجة الترسيم",
  lawyers_all_levels: "كل الدرجات",
  lawyers_by_governorate: "المحامون حسب الولاية",
  lawyers_page_of: "الصفحة {{page}} من {{pages}}",
  lawyers_empty_level: "لا يوجد محامون بهذه الدرجة في هذه الولاية.",
  pagination_label: "الصفحات",
  pagination_prev: "السابق",
  pagination_next: "التالي",
  breadcrumb_label: "مسار التصفح",
  profile_bar_level: "درجة الترسيم",
  profile_sworn_in: "سنة أداء اليمين",
  profile_bar_section: "الفرع الجهوي",
  profile_office_address: "عنوان المكتب",
  profile_city: "الولاية",
  profile_other_lawyers: "محامون آخرون في {{city}}",
  profile_claim: "هل أنت هذا المحامي؟ طالب بملفك",
  // Questions & answers pages redesign
  qa_latest: "آخر الأسئلة",
  qa_eyebrow: "أسئلة وأجوبة",
  qa_ask: "اطرح سؤالك",
  qa_ask_text: "اطرح سؤالك ليجيب عنه المحامون المسجّلون في المنصة.",
  qa_read_answers: "اقرأ الإجابات",
  qa_no_answers: "لا توجد إجابات بعد.",
  qa_no_answers_text: "يمكن للمحامين المسجّلين في المنصة الإجابة عن هذا السؤال.",
  qa_lawyer_badge: "محامٍ",
  qa_back: "كل الأسئلة",
  qa_empty: "لا توجد أسئلة منشورة بعد.",
  qa_question_label: "سؤال",
  qa_answer_error: "تعذّر نشر إجابتك. حاول مرة أخرى.",
  qa_save: "حفظ",
  // Lawyer dashboard redesign
  ldash_hello: "مرحبًا، الأستاذ {{name}}",
  ldash_lead: "تابع طلبات المواعيد وجدول أعمالك وإجاباتك من مكان واحد.",
  ldash_stat_pending: "طلبات بانتظار ردّك",
  ldash_public_profile: "عرض ملفي العام",
  ldash_username_add: "أضف اسم مستخدم",
  ldash_username_placeholder: "اسم مستخدم فريد",
  ldash_decline: "رفض",
  ldash_confirm_accept: "قبول هذا الموعد؟",
  ldash_confirm_decline: "رفض هذا الموعد؟",
  ldash_empty_list: "لا يوجد شيء في هذه القائمة.",
  ldash_premium_text: "ملفك يظهر للحرفاء ويمكنهم حجز مواعيد معك عبر الإنترنت.",
  ldash_free_text: "ملفك يظهر في جدول المحامين. لتفعيل حجز المواعيد عبر الإنترنت، تواصل معنا.",
  ldash_last_answer: "آخر إجابة",
  // User dashboard redesign
  dash_wrong_email: "ليس هذا بريدك الإلكتروني؟",
  dash_virtual: "عن بُعد",
  dash_hello: "مرحبًا، {{name}}",
  dash_lead: "تابع مواعيدك وأسئلتك القانونية من مكان واحد.",
  dash_stat_upcoming: "مواعيد قادمة",
  dash_stat_pending: "أسئلة بانتظار المراجعة",
  dash_question_sent: "تم إرسال سؤالك. سيُنشر بعد مراجعته.",
  dash_question_error: "تعذّر إرسال سؤالك. حاول مرة أخرى.",
  dash_email_note: "لا يمكن تغيير البريد الإلكتروني من هذه الصفحة.",
  dash_saving: "جارٍ الحفظ…",
  dash_verify_text: "أرسلنا رابط التفعيل إلى {{email}}. افتح الرابط لتفعيل حسابك.",
  dash_sending: "جارٍ الإرسال…",
  // About & contact pages redesign
  about_title: "ما هي أفوكنسلت؟",
  about_lead: "أفوكنسلت منصة سهلة وسريعة للعثور على محامٍ قريب منك في جدول المحامين وحجز موعد معه.",
  about_clients_title: "للحرفاء",
  about_clients_1: "اعثر بسرعة على محامٍ قريب منك واحجز موعدك عبر الإنترنت مجانًا.",
  about_clients_2: "اطرح أسئلتك القانونية عبر الإنترنت مباشرة على المحامين، مع احترام السرية.",
  about_clients_3: "اطّلع على إجابات المحامين عن أسئلة المستخدمين الآخرين.",
  about_lawyers_title: "للمحامين",
  about_lawyers_1: "أداة متكاملة لإدارة مكتب المحاماة، تحسّن تنظيمك وتوفّر وقتك.",
  about_lawyers_2: "شارك مواعيدك المتاحة مع حرفائك في الوقت الحقيقي وحسب معاييرك، مع الحفاظ على التحكم في جدول أعمالك.",
  about_lawyers_3: "تواصل مباشرة مع حرفائك وأجب عن أسئلتهم.",
  contact_eyebrow: "تواصل معنا",
  contact_title: "نحن في خدمتك",
  contact_form_title: "أرسل لنا رسالة",
  contact_sending: "جارٍ الإرسال…",
  contact_success: "شكرًا لتواصلك معنا. سنردّ عليك في أقرب الآجال.",
  contact_error: "تعذّر إرسال رسالتك. يُرجى إعادة المحاولة لاحقًا أو مراسلتنا عبر البريد الإلكتروني.",
  contact_email_title: "راسلنا",
  contact_find_lawyer_title: "تبحث عن محامٍ؟",
  contact_find_lawyer_text: "تصفّح جدول المحامين حسب الولاية أو الاسم.",
  contact_question_title: "لديك سؤال قانوني؟",
  contact_question_text: "اطرح سؤالك على المحامين في قسم الاستشارات القانونية.",
  // Lawyer profile page redesign
  Maps: "الموقع على الخريطة",
  profile_call: "اتصل بالمحامي",
  profile_fax: "الفاكس",
  profile_no_online_booking: "هذا المحامي لا يقبل حجز المواعيد عبر الإنترنت حاليًا. يمكنك الاتصال به هاتفيًا.",
  profile_hours_indicative: "ساعات تقريبية، يُرجى التأكد منها هاتفيًا.",
  profile_open_map: "فتح في خرائط Google",
  profile_court: "درجة الترسيم",
  // Magazine & lawyers pages redesign
  magazine_eyebrow: "مقالات ودلائل عملية",
  magazine_author: "فريق تحرير AvoConsulte",
  read_article: "اقرأ المقال",
  back_to_magazine: "العودة إلى المجلة",
  lawyers_eyebrow: "جدول المحامين",
  lawyers_title: "محامون في {{state}}",
  lawyers_title_all: "محامون في كامل تونس",
  lawyers_change_search: "جرّب اسمًا آخر أو ابحث في كل الولايات.",
  // Home page redesign
  home_eyebrow: "دليل المحامين في تونس",
  home_search_name_label: "اسم المحامي",
  home_search_city_label: "الولاية",
  home_all_cities: "كل الولايات",
  home_popular_cities: "ولايات شائعة",
  home_trust_states: "24 ولاية",
  home_trust_booking: "حجز المواعيد عبر الإنترنت",
  home_trust_advice: "استشارات قانونية من محامين",
  home_steps_eyebrow: "كيف يعمل",
  home_step1_title: "ابحث عن محامٍ",
  home_step2_title: "احجز موعدك",
  home_step3_title: "تلقَّ التذكير",
  home_cta_title: "هل أنت محامٍ؟",
  home_cta_text: "انضم إلى AvoConsulte واستقبل طلبات المواعيد من الحرفاء عبر الإنترنت.",
  home_cta_button: "انضم الآن",
  //(home page) Home Search component
  find_lawyer_near_you: "ابحث عن محام بالقرب منك",
  find_lawyer_near_you_description:
    "ابحث واعثر على محام في تونس واحجز موعدك عبر الإنترنت",

  search: "بحث",
  city: "مدينة",
  based_on_your_location: "بناء على موقعك",
  ex: "مثال: اسم المحامي",
  search_location: "موقع البحث",
  //(home page) Navbar component
  Home: "الرئيسية",
  LegalMagazine: "المجلة القانونية",
  LegalAdvice: "الاستشارات القانونية",
  Lawyers: "محامون",

  AboutUs: "من نحن",
  ContactUs: "اتصل بنا",
  PrivacyPolicy: "سياسة الخصوصية",
  Legal_Magazine: "المجلة-القانونية",
  Legal_Advice: "استشارات-قانونية",
  About_Us: "من-نحن",
  Contact_Us: "اتصل-بنا",
  Privacy_Policy: "الخصوصية-و-الأمن",
  Login: "تسجيل الدخول",
  arabic: "العربية",
  french: "الفرنسية",
  english: "الإنجليزية",
  my_account: "حسابي",
  nav_open_menu: "فتح القائمة",
  nav_close_menu: "إغلاق القائمة",
  nav_menu: "القائمة",
  nav_language: "اللغة",
  theme_label: "المظهر",
  theme_dark: "الوضع الداكن",
  theme_light: "الوضع الفاتح",
  footer_navigation: "التصفح",
  footer_by_city: "محامون حسب الولاية",
  footer_your_space: "فضاؤك",
  privacy_eyebrow: "الخصوصية",
  privacy_title: "سياسة الخصوصية",
  privacy_lead: "أمن بياناتك الشخصية وسريتها أولوية مطلقة لدى أفوكنسلت.",
  privacy_intro:
    "تبني أفوكنسلت علاقات قوية ودائمة مع مستخدميها قائمة على الثقة المتبادلة. توضح هذه الصفحة المعلومات التي تُجمع عند استخدامك للمنصة وكيفية استخدامها.",
  privacy_toc: "المحتويات",
  privacy_logs_title: "سجلات الدخول",
  privacy_logs_body:
    "قد تعتمد أفوكنسلت سجلات دخول كاملة تتضمن عنوان IP ونوع المتصفح ووقت التصفح ومدة البقاء في الموقع وتاريخ الدخول والروابط التي تمت زيارتها، وذلك لفهم طبيعة الزائر وتحسين الخدمة بشكل متواصل. ولا تُستخدم هذه البيانات أبدًا ولا يُروَّج لها ولا تُعرض على الزوار أو المستخدمين الآخرين كمعلومات شخصية.",
  privacy_cookies_title: "ملفات تعريف الارتباط (الكوكيز)",
  privacy_cookies_body:
    "نستخدم الكوكيز أحيانًا لمعرفة تفضيلات الزوار وتسلسل دخولهم إلى الموقع والروابط التي زاروها. وقد تُحفظ دون المساس بخصوصية المشترك أو بمعلوماته الشخصية.",
  privacy_third_title: "مواقع الأطراف الثالثة",
  privacy_third_body:
    "تعرض أفوكنسلت إعلانات جوجل وتستخدم خدمات مواقع خارجية، لذلك قد تُستخدم ملفات الكوكيز الخاصة بك لعرض إعلانات تناسب اهتماماتك. وقد تستخدم تلك المواقع، وأبرزها جوجل، عنوان IP الخاص بك لتحليل الكوكيز وقياس فعالية الإعلانات. لفهم ذلك أو الانسحاب منه يمكنك الاطلاع على توضيحات جوجل:",
  privacy_third_link: "إعدادات إعلانات جوجل",
  privacy_consulting_title: "خدمة الاستشارات",
  privacy_consulting_body:
    "تقدم أفوكنسلت خدمة استشارية خاصة، وبالتالي يمكن لفريق المستشارين والأطراف المعنية الاطلاع على وقائع قضيتك القانونية ومستجداتها. ولا تنشر أفوكنسلت أي قضية أو معلومة عبر منصتها دون موافقة مسبقة من الأطراف، من خلال الخيار المعروض في نافذة الاستشارة. وتُرسل الاستشارات الخاصة إلى بريد إلكتروني لا يظهر للعموم ومخصص لفريق المستشارين فقط، ما لم يرغب المشترك في عرض قضيته للعموم.",
  privacy_updates_title: "التحديثات",
  privacy_updates_body:
    "يُرجى الاطلاع على هذه السياسة بانتظام، وإن كان لديك أي استفسار يمكنك مراسلتنا على البريد الرئيسي للموقع. قد تتغير السياسة بناءً على توجيهات فريقنا القانوني، وعند أي تغيير سنرسل نسخة منها إلى المشتركين أو نعرض إشعارًا بذلك في صفحاتنا الرئيسية.",
  privacy_contact_title: "سؤال حول بياناتك؟",
  privacy_contact_text: "فريقنا في خدمتك عبر البريد الإلكتروني.",
  privacy_contact_btn: "اتصل بنا",
  // Operation Center (operators' console)
  oc_title: "مركز العمليات",
  oc_login_lead: "فضاء مخصص لفريق أفوكنسلت.",
  oc_email: "البريد الإلكتروني",
  oc_password: "كلمة المرور",
  oc_continue: "متابعة",
  oc_code: "رمز التحقق",
  oc_code_lead: "أدخل الرمز المكون من 6 أرقام المرسل إلى {{email}}.",
  oc_code_dev: "وضع التطوير: الرمز هو {{code}}.",
  oc_verify: "تسجيل الدخول",
  oc_back: "رجوع",
  oc_login_failed: "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
  oc_code_failed: "رمز غير صالح أو منتهي الصلاحية.",
  oc_network_error: "تعذر الاتصال بالخادم. حاول مجددًا.",
  oc_logout: "خروج",
  oc_nav_overview: "نظرة عامة",
  oc_nav_requests: "طلبات المحامين",
  oc_nav_lawyers: "المحامون",
  oc_nav_users: "المستخدمون",
  oc_nav_questions: "الأسئلة",
  oc_refresh: "تحديث",
  oc_search: "بحث",
  oc_all: "الكل",
  oc_loading: "جارٍ التحميل…",
  oc_empty: "لا يوجد ما يُعرض.",
  oc_error: "فشل التحميل.",
  oc_retry: "إعادة المحاولة",
  oc_page: "صفحة {{page}} من {{pages}}",
  oc_prev: "السابق",
  oc_next: "التالي",
  oc_results: "{{count}} نتيجة",
  oc_cancel: "إلغاء",
  oc_confirm: "تأكيد",
  oc_reason: "السبب (يُرسل بالبريد الإلكتروني)",
  oc_reason_required: "يرجى ذكر السبب.",
  oc_saved: "تم الحفظ.",
  oc_action_failed: "فشلت العملية: {{message}}",
  oc_view_profile: "عرض الملف",
  oc_status_pending: "قيد الانتظار",
  oc_status_approved: "مقبول",
  oc_status_rejected: "مرفوض",
  oc_status_published: "منشور",
  oc_status_closed: "مغلق",
  oc_ov_title: "نظرة عامة",
  oc_ov_updated: "آخر تحديث {{time}}",
  oc_ov_pending_requests: "طلبات محامين قيد الانتظار",
  oc_ov_pending_questions: "أسئلة للمراجعة",
  oc_ov_users: "المستخدمون المسجلون",
  oc_ov_lawyers_published: "المحامون المنشورون",
  oc_ov_unanswered: "أسئلة منشورة دون إجابة",
  oc_ov_appointments_pending: "مواعيد قيد الانتظار",
  oc_ov_weekly: "النشاط خلال 12 أسبوعًا الأخيرة",
  oc_ov_signups: "التسجيلات",
  oc_ov_questions: "الأسئلة المطروحة",
  oc_ov_appointments: "المواعيد المطلوبة",
  oc_ov_answers: "إجابات المحامين",
  oc_ov_week_of: "أسبوع {{date}}",
  oc_ov_total_12w: "{{count}} خلال 12 أسبوعًا",
  oc_ov_show_table: "عرض الجدول",
  oc_ov_hide_table: "إخفاء الجدول",
  oc_ov_week: "الأسبوع",
  oc_ov_count: "العدد",
  oc_ov_by_state: "المحامون المنشورون حسب الولاية",
  oc_ov_top_viewed: "الملفات الأكثر مشاهدة",
  oc_ov_views: "{{count}} مشاهدة",
  oc_ov_calls: "{{count}} اتصال",
  oc_ov_content: "المحتوى",
  oc_ov_questions_status: "الأسئلة",
  oc_ov_appointments_status: "المواعيد",
  oc_ov_articles: "المقالات المنشورة",
  oc_ov_answers_total: "الإجابات",
  oc_ov_clients: "الحرفاء",
  oc_ov_lawyer_accounts: "حسابات المحامين",
  oc_ov_suspended: "الحسابات الموقوفة",
  oc_appt_pending: "قيد الانتظار",
  oc_appt_confirmed: "مؤكدة",
  oc_appt_cancelled: "ملغاة",
  oc_req_submitted: "أُرسل الطلب في {{date}}",
  oc_req_reviewed: "عولج في {{date}}",
  oc_req_account: "الحساب",
  oc_req_email_verified: "البريد مؤكد",
  oc_req_email_unverified: "البريد غير مؤكد",
  oc_req_no_account: "لا يوجد حساب مرتبط",
  oc_req_duplicates: "موجود في الدليل مسبقًا؟",
  oc_req_duplicates_lead: "ملفات باسم مشابه: تأكد من أنه ليس ملفًا مكررًا.",
  oc_req_approve: "قبول",
  oc_req_reject: "رفض",
  oc_req_approve_confirm: "نشر هذا الملف في الدليل وفتح لوحة تحكم المحامي؟",
  oc_req_reject_title: "رفض طلب {{name}}",
  oc_req_reject_lead: "يعود الحساب حساب حريف. يُرسل السبب إلى المحامي.",
  oc_req_note: "ملاحظة",
  oc_law_visibility: "الظهور",
  oc_law_published: "منشور",
  oc_law_hidden: "مخفي",
  oc_law_source: "المصدر",
  oc_law_source_directory: "الدليل",
  oc_law_source_registered: "تسجيل",
  oc_law_name: "المحامي",
  oc_law_state: "الولاية",
  oc_law_stats: "الإقبال",
  oc_law_status: "الحالة",
  oc_law_actions: "إجراءات",
  oc_law_hide: "إخفاء",
  oc_law_publish: "نشر",
  oc_law_hide_confirm: "سحب {{name}} من الدليل العام؟",
  oc_law_publish_confirm: "نشر {{name}} في الدليل العام؟",
  oc_law_publish_warn_not_in_onat: "تنبيه: هذا المحامي غير موجود في جدول الهيئة الوطنية للمحامين الحالي (متقاعد أو متوفى أو غير مطابق). لا تنشره إلا إذا تثبّت من أنه يباشر المهنة.",
  oc_law_publish_warn_left_onat: "تنبيه: لم يعد هذا المحامي مدرجًا كمباشر في جدول الهيئة الوطنية للمحامين. لا تنشره إلا إذا تثبّت من أنه يباشر المهنة.",
  oc_law_not_in_onat: "غير موجود في جدول الهيئة",
  oc_law_left_onat: "غادر جدول الهيئة",
  oc_user_reactivate: "إعادة تفعيل الحساب",
  oc_user_reactivate_confirm: "إعادة تفعيل حساب {{name}}؟ سيتمكن من تسجيل الدخول مجددًا.",
  oc_law_search_ph: "الاسم أو البريد أو الهاتف أو رقم التسجيل",
  oc_usr_name: "المستخدم",
  oc_usr_role: "الدور",
  oc_usr_role_guest: "حريف",
  oc_usr_role_lawyer: "محامٍ",
  oc_usr_joined: "تاريخ التسجيل",
  oc_usr_activity: "النشاط",
  oc_usr_activity_value: "{{questions}} أسئلة · {{appointments}} مواعيد",
  oc_usr_status: "الحالة",
  oc_usr_active: "نشط",
  oc_usr_suspended: "موقوف",
  oc_usr_unverified: "البريد غير مؤكد",
  oc_usr_filter_suspended: "الموقوفون",
  oc_usr_filter_unverified: "البريد غير مؤكد",
  oc_usr_suspend: "إيقاف",
  oc_usr_unsuspend: "إعادة التفعيل",
  oc_usr_verify: "تأكيد البريد",
  oc_usr_suspend_confirm: "إيقاف حساب {{name}}؟ لن يتمكن من تسجيل الدخول.",
  oc_usr_verify_confirm: "تأكيد البريد الإلكتروني لـ {{name}} دون الرابط المرسل؟",
  oc_usr_search_ph: "الاسم أو البريد أو الهاتف",
  oc_q_by: "بواسطة {{name}}",
  oc_q_answers: "{{count}} إجابات",
  oc_q_publish: "نشر",
  oc_q_publish_confirm: "نشر هذا السؤال على الموقع؟ «{{title}}»",
  oc_q_reject: "رفض",
  oc_q_reject_title: "رفض السؤال «{{title}}»",
  oc_q_reject_lead: "يبقى السؤال خاصًا. يُرسل السبب إلى صاحبه الذي يمكنه تعديله.",
  oc_q_lang_ar: "العربية",
  oc_q_lang_fr: "الفرنسية",
  oc_q_search_ph: "العنوان أو المحتوى",
  oc_q_open: "فتح الصفحة",
  oc_nav_articles: "المقالات",
  oc_art_status_pending: "المسودات",
  oc_art_status_published: "المنشورة",
  oc_art_status_deleted: "الملغى نشرها",
  oc_art_lang_en: "الإنجليزية",
  oc_art_search_ph: "العنوان أو الملخص",
  oc_art_created_on: "كُتب في {{date}}",
  oc_art_published_on: "نُشر في {{date}}",
  oc_art_unpublished_on: "أُلغي نشره في {{date}}",
  oc_art_preview: "معاينة المقال",
  oc_art_hide: "إخفاء المعاينة",
  oc_art_view: "عرض على الموقع",
  oc_art_unpublish: "إلغاء النشر",
  oc_art_publish_title: "نشر «{{title}}»؟",
  oc_art_publish_lead: "يُنشر المقال في المجلة، ويحمل تاريخ اليوم إن لم يُنشر من قبل.",
  oc_art_unpublish_title: "إلغاء نشر «{{title}}»",
  oc_art_unpublish_lead: "يُسحب المقال من الموقع. يُحفظ السبب معه لفريق العمل.",
  //(home page) Look for a lawyer component
  Why_make_an_appointment_with_AvoConsulte:
    "لماذا تحدد موعد عن بعد مع AvoConsulte ?",
  Why_make_an_appointment_with_AvoConsulte_description:
    "مع AvoConsulte، خذ موعدًا عبر الإنترنت مع محاميك بطريقة أخرى",
  LOOK_FOR_A_LAWYER: "ابحث عن محامي",
  LOOK_FOR_A_LAWYER_DESCRIPTION: "تحصل على محاميك بسرعة",
  SEE_PROFILE: "انظر الملف الشخصي",
  SEE_PROFILE_DESCRIPTION: "خذ موعدا على الإنترنت في أي وقت",
  TAKE_HIS_CONTACT_INFORMATION: "خذ معلومات الاتصال الخاصة به",
  TAKE_HIS_CONTACT_INFORMATION_DESCRIPTION: "تلقى تذكير عبر رسائل إلكترونية",
  //(home page) Question section component
  Legal_advice: "استشارات قانونية",
  Legal_advice_description:
    "اطرح سؤالك على المحامين واطّلع على قائمة الأسئلة وإجاباتها.",
  View_All_question: "تحميل المزيد",
  Answers: "الإجابات",
  Share_the_post: "مشاركة المنشور",
  Answer_as_a_lawyer: "أجب بصفتك محاميًا",
  Answer_Question: "أجب على السؤال",
  Answer: "أجب",
  //(home page) Blog section component
  Legal_Magazine_title: "المجلة القانونية",
  Legal_Magazine_description:
    "المجلة القانونية لمنصتنا تحتوي على معلومات مفيدة وجميع الأخبار.",
  View_All_blog: "تحميل المزيد",
  No_content_available: "لا يوجد محتوى متاح",
  blog_is_not_available: "المدونة غير متاحة",
  // footer component
  AvoConsulte: "أفوكنسلت",
  All_rights_reserved: "جميع الحقوق محفوظة",
  Looking_for_a_lawyer: "هل تبحث عن محام؟",
  Register_as_Client: "سجل كعميل",
  Register_as_Lawyer: "سجل كمحام",
  POPULAR_SEARCHES: "عمليات البحث الشعبية",
  Lawyer_Tunis: "محامي تونس",
  Lawyer_Ariana: "محامي أريانة",
  Lawyer_Sfax: "محامي صفاقس",
  Lawyer_Sousse: "محامي سوسة",
  Lawyer_Manouba: "محامي منوبة",
  Lawyer_Nabeul: "محامي نابل",
  Lawyer_Kairouan: "محامي القيروان",
  Lawyer_Sidi_Bouzid: "محامي سيدي بوزيد",
  Lawyer_Siliana: "محامي سليانة",
  Lawyer_Gafsa: "محامي قفصة",
  Lawyer_Jendouba: "محامي جندوبة",
  Lawyer_Kebili: "محامي قبلي",
  Lawyer_Zaghouan: "محامي زغوان",
  Lawyer_Ben_arous: "محامي بن عروس",
  Lawyer_beja: "محامي باجة",
  Lawyer_Tozeur: "محامي توزر",
  Lawyer_Monastir: "محامي المنستير",
  Lawyer_Gabes: "محامي قابس",
  Lawyer_Mahdia: "محامي المهدية",
  Lawyer_Bizerte: "محامي بنزرت",
  Lawyer_Kasserine: "محامي القصرين",
  Lawyer_Medenine: "محامي مدنين",
  //Question page component
  Load_More: "تحميل المزيد",
  Latest_Posts: "آخر المنشورات",
  //Lawyers page component
  No_lawyer_found: "لا يوجد محامي",
  View_Profile: "عرض الملف الشخصي",
  Book_Appointment: "حجز موعد",
  Search_Filter: "بحث ",
  Phone_numbers: "ارقام هواتف",
  Lawyers_p: "المحامين",
  Description_Lawyer_p: "ابحث على أفضل المحامين واحجز موعدك عبر الإنترنت",
  //Lawyer profile page component
  Phone_number: "رقم الهاتف",
  Lawyer_Contact_information: "معلومات الاتصال",
  Close: "إغلاق",
  Not_Available: "غير متوفر",
  Overview: "نظرة عامة",
  Business_Hours: "ساعات العمل",
  no_further_information: "لا توجد معلومات أخرى عن",
  No_busniess_hours_specified: "لا توجد ساعات عمل محددة",
  Open_Now: "متاح الآن",
  Closed_Now: "مغلق الآن",
  Closed: "مغلق",
  appel: "محامي لدى الإستئناف",
  cassation: "محامي لدى التعقيب",
  permiere: "محامي لدى المحكمة الإبتدائية",
  premiere: "محامي لدى المحكمة الإبتدائية",
  Today: "اليوم",
  Education: "العمل و التعليم",
  Services: "الخدمات",
  //About us page component
  What_is_AvoConsulte: "ما هو أفوكنسلت؟",
  Avoconsulte_AboutUs_p1:
    "أفوكنسلت هي منصة سريعة وسهلة لتحديد موعد مع محام متاح بالقرب منك من دليل المحامين لتلبية احتياجاتك",
  For_customers: "للعملاء",
  For_customers_p1:
    "أفوكنسلت هي منصة مبتكرة تتيح لك العثور بسرعة على محام بالقرب منك وتحديد موعد عبر الإنترنت مجانًا.",
  For_customers_p2:
    "يسمح لك أفوكنسلت بطرح أسئلتك على الإنترنت مباشرة للمحامين مع احترام شروط السرية.",
  For_customers_p3:
    "يسمح لك أفوكنسلت بالعثور على إجابة لأسئلتك عبر الإنترنت يتم الرد عليها مباشرة من قبل المحامين المؤهلين.",
  For_legal_professionals: "للمحامين",
  For_legal_professionals_p1:
    "أفوكنسلت هي خدمة إدارة مكتب محاماة شاملة تعمل على تحسين مؤسستك وتوفر لك الوقت.",
  For_legal_professionals_p2:
    "، خدمة إدارة الكابينة الكاملة ، تشارك توافرك في الوقت الفعلي مع عملائك بناءً على المعايير الخاصة بك ، مع الحفاظ على التحكم في جدول أعمالك القانوني ، وتحسين مؤسستك ، وتوفير الوقت لك",
  For_legal_professionals_p3:
    "يتيح لك التواصل مباشرة مع العملاء والإجابة على أسئلتهم.",
  With: "مع",
  Testimonials: "آراء العملاء",
  Checkout_what_people_think_about_Us: "تحقق من ما يقول العملاء عنا",
  //contact us page component
  Contact_us_for_further_information_or_assistance:
    "اتصل بنا للحصول على معلومات أو مساعدة أخرى",
  Email: "البريد الإلكتروني",
  Location: "الموقع",
  Phone: "الهاتف",
  Get_in_touch: "ابقى على تواصل!",
  Your_Name: "اسمك",
  Your_Email: "بريدك الإلكتروني",
  Subject: "الموضوع",
  Message: "الرسالة",
  Send_Message: "إرسال الرسالة",
  Thank_you_for_reaching_out_to_us: "شكرا لك على الاتصال بنا",
  // login page component
  Password: "كلمة المرور",
  Forgot_Password: "هل نسيت كلمة المرور؟",
  or: "أو",
  Dont_have_an_account: "ليس لديك حساب؟",
  Are_you_a_Lawyer: "هل أنت محام؟",
  Register_here: "سجل هنا",
  login_email_Required: "البريد الإلكتروني إجباري",
  login_email_Invalid: "البريد الإلكتروني غير صالح",
  login_password_Required: "كلمة المرور إجبارية",
  login_failed: "خطأ في تسجيل الدخول",
  // register page component
  Register: "تسجيل",
  Mobile_Number: "رقم الجوال",
  Create_Password: "إنشاء كلمة مرور",
  Confirm_Password: "تأكيد كلمة المرور",
  Already_have_an_account: "هل لديك حساب؟",
  Signup: "تسجيل",
  Full_Name: "الاسم الكامل",
  Last_Name: "اللقب ",
  First_Name: "الاسم ",
  Date_of_birth: "تاريخ الميلاد",
  register_first_Name_Required: "الاسم إجباري",
  register_last_Name_Required: "اللقب  إجبارية",
  register_email_Invalid: "البريد الإلكتروني غير صالح",
  register_email_Required: "البريد الإلكتروني إجباري",
  register_password_MinLength: "يجب أن يكون طول كلمة المرور 8 أحرف على الأقل",
  register_password_Required: "كلمة المرور إجبارية",
  register_passwordMatch: "كلمة المرور غير متطابقة",
  register_confirm_Password_Required: "تأكيد كلمة المرور إجباري",
  register_dob_Required: "تاريخ الميلاد إجباري",
  Register_failed: "خطأ في التسجيل ، الرجاء المحاولة مرة أخرى",
  This_email_is_linked_to_another_account:
    "هذا البريد الإلكتروني مرتبط بحساب آخر",
  //Dashboard
  your_profile_has_been_updated_successfully: "تم تحديث ملفك الشخصي بنجاح",
  error_occurred_while_updating_your_profile: "حدث خطأ أثناء تحديث ملفك الشخصي",
  Dashboard: "لوحة التحكم ",
  My_Dashboard: "لوحة تحكمي",
  Profile_Settings: "الملف الشخصي",
  Logout: "خروج",
  Appointments: "المواعيد",
  Ask_Question: "اطرح سؤالًا",
  My_Questions: "أسئلتي",
  Appt_Date: "تاريخ الموعد",
  Booking_Date: "تاريخ الحجز",
  Booking_type: "نوع الحجز",
  Status: "الحالة",
  Lawyer: "المحامي",
  You_havent_book_any_appointmen_yet: "لم تقم بحجز أي موعد",
  You_havent_asked_any_question_yet: "لم تسأل سؤالا بعد",
  Question_Title: "عنوان السؤال",
  Question_Description: "وصف السؤال",
  ID: "الرقم",
  Date: "التاريخ",
  Title: "العنوان",
  Password_Security: "كلمة المرور والأمان",
  Old_password: "كلمة المرور القديمة",
  enter_your_old_password: "أدخل كلمة المرور القديمة",
  New_password: "كلمة المرور الجديدة",
  enter_your_new_password: "أدخل كلمة المرور الجديدة",
  Confirm_new_password: "تأكيد كلمة المرور الجديدة",
  confirm_your_new_password: "تأكيد كلمة المرور الجديدة",
  Save_Changes: "حفظ التغييرات",
  Personal_Information: "معلومات شخصية",
  Services_and_Educations_Information: "الخدمات والتعليم",
  View: "عرض",
  Accept: "قبول",
  Cancel: "إلغاء",
  Edit: "تعديل",
  Delete: "حذف",
  Review: "مراجعة",
  Change_Password: "تغيير كلمة المرور",
  password_has_been_changed_successfully: "تم تغيير كلمة المرور بنجاح",
  error_occurred_while_changing_your_password:
    "حدث خطأ أثناء تغيير كلمة المرور",
  profile_update_success: "تم تحديث الملف الشخصي بنجاح",
  Update: "تحديث",
  profile_update_failed: "فشل تحديث الملف الشخصي",
  pending: "قيد الانتظار",
  accepted: "مقبول",
  confirmed: "تم التأكيد",
  rejected: "مرفوض",
  cancelled: "ملغي",
  Edite_Question: "تعديل السؤال",
  Become_Lawyer: "كن محاميًا",
  Name_in_arabic: "الاسم بالعربية",
  Name_in_french: "الاسم بالفرنسية",
  Address_in_arabic: "العنوان بالعربية",
  Address_in_french: "العنوان بالفرنسية",
  Delegation: "المعتمدية",
  Ask_Another_Question: "اسأل سؤالا آخر",
  your_account_is_under_review: "حسابك في انتظار المراجعة",
  review_your_application:
    "ستتلقى بريدًا إلكترونيًا بمجرد مراجعة طلبك ، شكرا لاستخدامك خدماتنا",
  error_occurred_while_submitting_your_application:
    "حدث خطأ أثناء تقديم طلبك ، الرجاء المحاولة مرة أخرى",
  Check_your_email_for_the_verification_link:
    "تحقق من بريدك الإلكتروني للحصول على رابط التحقق",
  Verify_your_account_please: "يُرجى تفعيل حسابك",
  this_is_not_your_correct_email: "هذا ليس بريدك الإلكتروني الصحيح",
  Change_email: "تغيير البريد الإلكتروني",
  you_are_already_using_this_email: "أنت تستخدم هذا البريد الإلكتروني بالفعل",
  something_went_wrong_please_try_again: "حدث خطأ ما، الرجاء المحاولة مرة أخرى",
  //Account verification
  Your_account_has_been_verified_successfully: "تم تحقق حسابك بنجاح",
  error_occurred_while_verifying_your_account:
    "حدث خطأ أثناء تحقيق حسابك ، الرجاء المحاولة مرة أخرى",
  verifying: "تحقق",
  verification: "التحقق",
  very_nice_you_made_it: "جميل جدا تم تحقيق حسابك",
  go_to_login: "الذهاب إلى تسجيل الدخول",
  //lawyer dashboard
  Social_Media: "وسائل التواصل الاجتماعي",
  Messages: "رسائل",
  Accounts: "حسابات",
  Invoices: "الفواتير",
  Available_Timings: "ساعات العمل",
  Schedule_Timings: "جدول أعمال",
  Clients: "العملاء",
  Today_Appointments: "مواعيد اليوم",
  My_Answers: "إجاباتي",
  You_dont_have_any_appointmen_yet: "ليس لديك أي موعد",
  Today_Clients: "العملاء اليوم",
  Total_Clients: "عدد العملاء",
  Appoinments: "المواعيد",
  You_havent_answered_any_question_yet: " لم تجب على أي سؤال",
  Appointment_Details: "تفاصيل الموعد",
  End_Time: "وقت الانتهاء",
  Start_Time: "وقت البدء",
  you_dont_have_any_appointment: "ليس لديك أي موعد ",
  Till_Today: "حتى اليوم",
  in_Person: "شخصيا",
  Client: "العميل",
  add_event: "إضافة موعد",
  startDate: "تاريخ البدء",
  endDate: "تاريخ الانتهاء",
  //booking page
  Book_now: "إحجز الآن",
  Monday: "الإثنين",
  Tuesday: "الثلاثاء",
  Wednesday: "الأربعاء",
  Thursday: "الخميس",
  Friday: "الجمعة",
  Saturday: "السبت",
  Sunday: "الأحد",
  Thank_You: "شكرا",
  error_while_schudling_your_appointement: "حدث خطأ أثناء تحديد موعدك",
  subject_is_required: "الموضوع إجباري",
  description_is_required: "الوصف إجباري",
  time_is_required: "الوقت إجباري",
  Booking_information: "معلومات الحجز",
  //thank you page
  Appointment_booked_Successfully: "تم حجز موعد بنجاح",
  //lawyer register page
  Full_name: "الاسم الكامل",
  Adress: "العنوان",
  phone_number: "رقم الهاتف",
  office_phone: "رقم المكتب",
  court: "المحكمة",
  state: "الولاية",
  cour_d_appel: "محكمة الإستئناف ",
  cour_de_cassation: "محكمة التعقيب ",
  cour_a_la_permiere: "المحكمة الإبتدائية",
  register_full_Name_Required: "الاسم الكامل إجباري",
  register_Adress_Required: "العنوان إجباري",
  register_phone_Required: "رقم الهاتف إجباري",
  register_office_Required: "رقم المكتب إجباري",
  register_court_Required: "المحكمة إجبارية",
  register_state_Required: "الولاية إجبارية",
  Choose_court: "اختر المحكمة",
  Lawyer_account_request: "طلب حساب محام",
  Submit_Request: "إرسال الطلب",
  document_upload: "تحميل المستند",
  My_Lawyer_Account: "حسابي كمحامٍ",
  About_Me: "عني",
  bref_description: "وصف مختصر",
  Required: "إجباري",
  //States
  Choose_delegation: "اختر المعتمدية",
  Choose_state: "اختر الولاية",
  Tunis: "تونس",
  Ariana: "أريانة",
  Ben_Arous: "بن عروس",
  Mannouba: "منوبة",
  Sousse: "سوسة",
  Sfax: "صفاقس",
  Nabeul: "نابل",
  Sidi_Bouzid: "سيدي بوزيد",
  Beja: "باجة",
  Tozeur: "توزر",
  Monastir: "منستير",
  Mahdia: "مهدية",
  Bizerte: "بنزرت",
  Kasserine: "القصرين",
  Jendouba: "جندوبة",
  Kef: "الكاف",
  Medenine: "مدنين",
  Kairouan: "القيروان",
  Gabes: "قابس",
  Kebili: "قبلي",
  Zaghouan: "زغوان",
  Siliana: "سليانة",
  Tataouine: "طرقين",
  Gafsa: "قفصة",
  //membership
  membership: "الاشتراك",
  you_have_premium_membership: "لديك العضوية المدفوعة",
  you_have_free_membership: "لديك العضوية المجانية",
  thank_you_for_choosing_avoconsulte: "شكرا لاختيار Avoconsulte",
  // Editorial FAQ, topic pages and internal links
  faq_editorial_badge: "إجابة فريق تحرير AvoConsulte",
  faq_editorial_team: "فريق تحرير AvoConsulte",
  faq_editorial_note: "هذه الإجابة من إعداد فريق تحرير AvoConsulte وليست من محامٍ. هي معلومات عامة ولا تغني عن استشارة محامٍ يدرس وضعيتك الخاصة.",
  faq_related_guide: "اقرأ الدليل الكامل",
  faq_more_in_topic: "أسئلة أخرى في هذا الموضوع",
  faq_ask_own: "اطرح سؤالك الخاص",
  faq_ask_own_text: "وضعيتك مختلفة؟ اطرح سؤالك على المحامين المرسّمين في المنصة.",
  find_lawyer_title: "ابحث عن محامٍ في مدينتك",
  find_lawyer_text: "دليل المحامين المرسّمين بالهيئة الوطنية للمحامين، حسب الولاية.",
  find_lawyer_all: "كل المحامين في تونس",
  related_title: "مواضيع ذات صلة",
  related_kind_guide: "دليل",
  related_kind_faq: "سؤال شائع",
  sources_title: "المصادر",
  sources_new_tab: "(يفتح في نافذة جديدة)",
  article_last_updated: "آخر تحديث",
  read_in: "اقرأ بـ:",
  topic_label: "الموضوع",
  topics_title: "المواضيع",
  topic_guides: "الأدلة",
  topic_faq: "أسئلة شائعة",
  oc_q_editorial: "تحرير",
  oc_q_editorial_only: "أسئلة التحرير فقط",
  oc_q_kind: "النوع",
  oc_q_kind_visitors: "أسئلة الزوار",
  oc_q_editorial_answer: "إجابة فريق التحرير",
  oc_q_editorial_by: "فريق تحرير AvoConsulte",
  oc_q_lang_en: "الإنجليزية",
  page_loading: "جارٍ التحميل…",
};
